import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import ZonesHero from './components/ZonesHero';
import ZonesGrid from './components/ZonesGrid';
import ZonesCTA from './components/ZonesCTA';
import SEOHead from '@/components/feature/SEOHead';

const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Zones d'Intervention Suisse Romande - CasaReNovaPlus",
  "description": "CasaReNovaPlus intervient dans toute la Suisse romande : Neuenegg, Fribourg, Berne, Vaud, Valais, Neuchâtel, Jura. Rénovation, CVSE, électricité, plomberie, chauffage.",
  "url": `${import.meta.env.VITE_SITE_URL}/zones-intervention`,
  "provider": {
    "@type": "LocalBusiness",
    "name": "CasaReNovaPlus",
    "telephone": "+41797616282",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Neuenegg",
      "addressRegion": "Fribourg",
      "addressCountry": "CH"
    },
    "areaServed": [
      { "@type": "City", "name": "Genève" },
      { "@type": "City", "name": "Lausanne" },
      { "@type": "AdministrativeArea", "name": "Canton de Vaud" },
      { "@type": "AdministrativeArea", "name": "Canton de Fribourg" },
      { "@type": "AdministrativeArea", "name": "Canton du Valais" },
      { "@type": "AdministrativeArea", "name": "Canton de Neuchâtel" },
      { "@type": "AdministrativeArea", "name": "Canton du Jura" }
    ]
  }
};

export default function ZonesIntervention() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Zones d'Intervention Suisse Romande | Neuenegg Fribourg Berne Vaud Valais - CasaReNovaPlus"
        description="CasaReNovaPlus intervient dans toute la Suisse romande : Neuenegg, Fribourg, Berne, Vaud, Valais, Neuchâtel, Jura. Rénovation, CVSE, électricité, plomberie. Devis gratuit, urgence 24/7."
        keywords="zones intervention Suisse romande, CVSE Genève Lausanne, électricien Vaud Fribourg, plombier Valais Neuchâtel, chauffage Jura Suisse romande, HB SERVICES zones"
        canonical={`${import.meta.env.VITE_SITE_URL}/zones-intervention`}
        schema={schema}
      />
      <Header />
      <ZonesHero />
      <ZonesGrid />
      <ZonesCTA />
      <Footer />
    </div>
  );
}
